import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconMic = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--mic")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M19,9 C19.5522847,9 20,9.44771525 20,10 L20,10 L20,12 C20,16.0792885 16.9468042,19.445465 13.0009551,19.9379871 L13,22 L16,22 C16.5128358,22 16.9355072,22.3860402 16.9932723,22.8833789 L17,23 C17,23.5522847 16.5522847,24 16,24 L16,24 L8,24 C7.44771525,24 7,23.5522847 7,23 C7,22.4477153 7.44771525,22 8,22 L8,22 L11,22 L11.0000487,19.9381123 C7.13435348,19.456091 4.12517261,16.2160131 4.00380682,12.2491793 L4,12 L4,10 C4,9.44771525 4.44771525,9 5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,12 C6,15.3137084 8.68629154,18 12,18 C15.3137085,18 18,15.3137084 18,12 L18,12 L18,10 C18,9.44771525 18.4477153,9 19,9 Z M12,0 C14.209139,0 16,1.790861 16,4 L16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 L8,4 C8,1.790861 9.790861,0 12,0 Z M12,2 C10.8954305,2 10,2.8954305 10,4 L10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 L14,4 C14,2.8954305 13.1045695,2 12,2 Z" id="icon--centivo--mic"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1959.000000, -749.000000)"/>
          <g id="Icon/mic">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--mic"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--mic"/>
          </g>
      </g>
  </IconWrapper>
)
